import axios from "axios";
import { urls } from "../core/db";
import {
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_DETAILS_RESET,
  USER_LIST_FAIL,
  USER_LIST_SUCCESS,
  USER_LIST_REQUEST,
  USER_LIST_RESET,
  USER_DELETE_REQUEST,
  USER_DELETE_SUCCESS,
  USER_DELETE_FAIL,
  USER_UPDATE_FAIL,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_REQUEST,
} from "../constants/userConstants";
import api from "../core/api";

export const login = (Username, Password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      urls.accountingusersUrl + "/login",
      { Username, Password },
      config,
    );

    if (data.Result.includes("Error")) {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: data.accesstoken,
      });

      const dt2 = new Date(Date.now() + 24 * 60 * 60 * 1000);
      localStorage.setItem("accinf", JSON.stringify(data.Result));
      localStorage.setItem("acdt", JSON.stringify(dt2.getTime()));
      document.location.href = "/";
    }
    //window.location.pathname('/')
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("accinf");
  localStorage.removeItem("expdt");
  localStorage.clear();
  dispatch({ type: USER_LOGOUT });
  dispatch({ type: USER_DETAILS_RESET });
  dispatch({ type: USER_LIST_RESET });
  document.location.href = "/login";
};

export const getUserDetails = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });
    const { data } = await api.get(`/accounts/users`);

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: USER_DETAILS_FAIL,
      payload: message,
    });
  }
};

export const listUsers = (getAll) => async (dispatch, getState) => {
  try {
    console.log(getAll);

    dispatch({ type: USER_LIST_REQUEST });

    const { data } = await api.get(
      getAll ? `/accounts/users/getall` : `/accounts/users`,
    );
    var dt = data.Result;

    if (typeof dt == "string") {
      dispatch({
        type: USER_LIST_FAIL,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: USER_LIST_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: USER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
